var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducationDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#2EEFAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5171 24.7646C32.8458 24.6318 33.2045 24.8737 33.2045 25.2282V29.6848C33.2045 32.5094 27.267 33.8458 23.9737 33.8458C20.8435 33.8458 14.7429 32.4181 14.7429 29.6848V24.0679C14.7429 23.6892 15.1475 23.448 15.4806 23.628L23.7668 28.1053C23.8978 28.1761 24.0537 28.1848 24.1918 28.129L32.5171 24.7646ZM25.1327 13.4551C24.9952 13.3782 24.8295 13.3707 24.6856 13.4348L12.5935 18.8176C12.2146 18.9863 12.194 19.5164 12.5587 19.714L23.7672 25.7853C23.898 25.8561 24.0536 25.865 24.1917 25.8096L34.5694 21.6424C34.898 21.5105 35.2558 21.7524 35.2558 22.1064V28.2176C35.2558 28.4938 35.4796 28.7176 35.7558 28.7176H36.807C37.0832 28.7176 37.307 28.4938 37.307 28.2176V20.5495C37.307 20.3683 37.209 20.2013 37.0509 20.113L25.1327 13.4551ZM37.9753 33.0931C38.1209 33.4414 37.8766 33.8458 37.4991 33.8458H35.0966C34.7116 33.8458 34.4627 33.4236 34.6087 33.0673C34.9436 32.2498 35.1808 31.2586 35.2408 30.243C35.2572 29.9673 35.4796 29.7433 35.7558 29.7433H36.807C37.0832 29.7433 37.3055 29.9674 37.321 30.2431C37.3791 31.281 37.6162 32.2341 37.9753 33.0931Z",
    fill: "#CEFFEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationDetail);
export default __webpack_public_path__ + "static/media/education-detail.ee11a3e5.svg";
export { ForwardRef as ReactComponent };